import NiceModal, { useModal } from "@ebay/nice-modal-react";
import SideModal from "/src/components/modal/SideModal/SideModal";
import useModalHelper from "/src/components/modal/hooks/useModalHelper";
import Form from "/src/components/form/Form";
import Field from "/src/components/UI/Field/Field";
import TextInput from "/src/components/UI/TextField/TextInput";
import Button from "/src/components/UI/Button/Button";
import { useForm } from "react-hook-form";
import unitAdminService from "../../services/unitAdminService";
import "./UnitLabelModal.css";

const UnitLabelModal = NiceModal.create(({ title, data }) => {
    const modal = useModal();
    const { onClose } = useModalHelper(modal);
    const { createUnitLabel, updateUnitLabel } = unitAdminService;

    const { register, handleSubmit, formState: { errors, isValid } } = useForm({
        mode: "onChange",
        defaultValues: { unit_id: data?.unit_id || "", label: data?.label || "" },
    });

    const onSubmit = async (values) => {
        const [response, error] = data
            ? await updateUnitLabel(data.id, values)
            : await createUnitLabel(values);

        if (error) {
            console.error(error);
            return;
        }
        modal.resolve(response);
        onClose();
    };

    return (
        <SideModal name="unit-label-modal" id={modal.id} autoClose="true" onClose={onClose} style={{ width: "500px" }}>
            <div className="button-leave" id="close_modal_container" onClick={() => onClose()}>
                <i id="close_modal" className="fa fa-times" aria-hidden="true"></i>
            </div>
            <Form className="unit-form" onSubmit={handleSubmit(onSubmit)}>
                <Form.Title>{title}</Form.Title>
                <Form.Body className="unit-form-body">
                    <Field label={<span>Unit ID <span className="obligatory_field">*</span></span>}>
                        <TextInput placeholder="anytech365-in-none-none-dk" {...register("unit_id", { required: true })} />
                        <span className="error-display">{errors.unit_id ? "Unit ID is required" : ""}</span>
                    </Field>
                    <Field label={<span>Label <span className="obligatory_field">*</span></span>}>
                        <TextInput placeholder="Inbound DK" {...register("label", { required: true })} />
                        <span className="error-display">{errors.label ? "Label is required" : ""}</span>
                    </Field>
                </Form.Body>
                <Form.Buttons>
                    <Button type="submit" label="Save" className="validate" disabled={!isValid} />
                </Form.Buttons>
            </Form>
        </SideModal>
    );
});

export default UnitLabelModal;
